<template src="./templates/support-edit.html" />

<script type="text/ecmascript-6">
import FouAccordion from 'components/tools/fou-accordion/'
import FouAccordionItem from 'components/tools/fou-accordion/item'
import FouContainer from 'src/components/tools/fou-container/'
import SubmissionLoading from 'src/pages/submissions/components/loading/'
import { SubmissionObject } from 'src/pages/submissions/script/common.data'
import SubmissionComputed from 'src/pages/submissions/script/common.computed'
import SubmissionMethods from 'src/pages/submissions/script/common.methods'
import FouGroup from 'src/components/layout/fou-group/'
import FouGrid from 'src/components/layout/fou-grid/'
import Results from 'src/pages/submissions/components/upload/results'
import Prices from 'src/pages/submissions/components/prices/'
import Descriptions from 'src/pages/submissions/components/descriptions/'
import Graphics from 'src/pages/submissions/components/graphics/'
import DefaultStyle from 'src/pages/submissions/components/upload/defaultStyle'
import Designers from 'src/pages/submissions/components/upload/designers'
import Externalsku from 'src/pages/submissions/components/upload/externalsku'
import { mapActions } from 'vuex'

export default {
  name: 'SubmissionsSupportEdit',

  components: {
    FouAccordion,
    FouAccordionItem,
    FouContainer,
    FouGroup,
    ...FouGrid,
    Results,
    Prices,
    Descriptions,
    Graphics,
    SubmissionLoading,
    DefaultStyle,
    Designers,
    Externalsku
  },

  data() {
    return {
      ...SubmissionObject,
      ready: {
        name: this.$options.name,
        state: 'unset'
      }
    }
  },
  computed: {
    ...SubmissionComputed,
    enableButton() {
      return this.readyStates.every(item => item.state === 'set')
    }
  },

  created() {
    this.addReadyState()
    this.resetSubmissionFormat()
    this
      .startSubmission()
      .then(() => {
        this.setDefaultUser()
        this.updateSubmissionSteps()
        this.ready.state = 'set'
        this.getFoundryById({ foundryId: this.submission?.foundry?.foundryId })
      })
  },
  methods: {
    ...SubmissionMethods,
    ...mapActions('foundrySupport', ['getFoundryById']),
    navigateToReview() {
      this.updateSubmission().then(() => {
        this.$router.push({
          name: 'submissions_support_review',
          params: { id: this.submission.id }
        })
      })
    }
  }
}
</script>

<style src="./stylesheets/index.scss" lang="scss" module></style>
